/* Nola — card color swatches: tap swaps card image to variant media and
   appends ?variant= to the card link. Event delegation, works after
   drawer/section re-renders. No metafields, no app. */
document.addEventListener('click', function (e) {
  var sw = e.target.closest('.nb-swatch');
  if (!sw) return;
  var card = sw.closest('.nb-card, .card-wrapper');
  if (!card) return;
  e.preventDefault();
  var group = sw.closest('[data-nb-swatches]');
  group.querySelectorAll('.nb-swatch').forEach(function (b) {
    b.classList.remove('is-active');
    b.setAttribute('aria-pressed', 'false');
  });
  sw.classList.add('is-active');
  sw.setAttribute('aria-pressed', 'true');
  var img = card.querySelector('.nb-card__img--primary, .card__media img');
  if (img && sw.dataset.img) {
    img.removeAttribute('srcset');
    img.src = sw.dataset.img;
  }
  if (sw.dataset.variant) {
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var base = a.href.split('?')[0];
      a.href = base + '?variant=' + sw.dataset.variant;
    });
  }
});
